import { JSONMap } from "models/ApiResponseModel";
export class AuthRoleSimpleModel {
    id: number;
    title: string;
    isActive: boolean;
    constructor(
        id: number,
        title: string,
        isActive: boolean,
    ) {
        this.id = id;
        this.title = title;
        this.isActive = isActive;
    }

    public static fromJson(json: any): AuthRoleSimpleModel {
        return new AuthRoleSimpleModel(
            json["id"],
            json["title"],
            json["isActive"]
        );
    }
}


export class RoleFilterPayload {
    Id: number = 0;
    Title: string = ''
    IsActive: number = -1;
    IsAdmin: number = -1;
    constructor(
    ) {
    }
}

export class AuthRoleGetPaload {
    reload?: number;
    pageNumber: number = 0;
    pageSize: number = 10;
    Filters?: RoleFilterPayload;
}


export class AuthRolePayloadModel {
    Id: number;
    Title: string;
    IsActive: boolean;

    constructor(
        Id: number,
        Title: string,
        IsActive: boolean,
    ) {
        this.Id = Id;
        this.Title = Title;
        this.IsActive = IsActive;
    }
}
